import { mxConfig } from '../config';

if (mxConfig.twitterId?.length) {
  //@ts-ignore
  window.twq('config', mxConfig.twitterId);
}
